<template>
  <div class="header-content">
    <div class="d-flex full-width justify-content-between align-items-center">
      <img :src="invoiceLogo" alt="logo" class="logo-img" :style="logoStyle" />
      <DetailBox
        item-type="Invoice"
        :item-id="invoice.invoice_id"
        :job-id="invoice.job_id"
        :date="invoiceDate"
        :addresses-materialized="addressesMaterialized"
        :billing-name="billingCustomerName"
        :billing-address="billingAddress"
        :service-name="serviceAddressLocationName"
        :service-address="serviceAddress"
      ></DetailBox>
    </div>
    <div class="invoice-details">
      <p v-if="invoice.show_summary && invoice.summary" class="invoice-summary">
        {{ invoice.summary }}
      </p>
    </div>
    <div class="summary-text">ORDER SUMMARY</div>
  </div>
</template>

<script lang="ts">
import {
  formatAddressLines,
  formatDate
} from "serviceshift-ui/shared/src/mixins";

import { Customizations } from "@/typings/customizations";
import { Invoice } from "@/typings/invoice";
import DetailBox from "./DetailBox.vue";

export default {
  components: {
    DetailBox
  },
  props: {
    invoice: {
      type: Object as () => Invoice,
      default: null
    },
    customizations: {
      type: Object as () => Customizations,
      default: null
    },
    tenantTimezone: {
      type: String,
      default: ""
    }
  },
  computed: {
    invoiceLogo() {
      if (this.customizations) {
        const darkLogo = this.customizations.Assets.dark_logo_url;
        return darkLogo.value || darkLogo.default;
      }
      return "";
    },
    customerName() {
      return this.invoice?.customer?.full_name ?? "";
    },
    billingCustomerName() {
      return this.invoice?.billing_customer?.full_name ?? this.customerName;
    },
    invoiceDate() {
      return this.invoice?.invoice_date
        ? formatDate(this.invoice.invoice_date, {
            timezone: this.tenantTimezone
          })
        : "--";
    },
    billingAddress() {
      return formatAddressLines(this.invoice?.billing_address);
    },
    serviceAddress() {
      return formatAddressLines(this.invoice?.service_address);
    },
    serviceAddressLocationName() {
      return this.invoice?.service_address?.name ?? "";
    },
    addressesMaterialized() {
      return this.invoice?.finalized;
    },
    logoStyle() {
      if (this.customizations) {
        const logo_size_percentage =
          this.customizations.General.logo_size_percentage;
        const value =
          logo_size_percentage.value || logo_size_percentage.default;
        return `max-width:${value};`;
      }
      return "";
    }
  },
  mounted() {
    window.tippy("[data-tippy-content]");
  }
};
</script>

<style lang="scss" scoped>
.header-content {
  display: flex;
  flex-direction: column;
}

.logo-img {
  max-height: 185px;
  flex-shrink: 0;
}

.summary-text {
  font-size: 14px;
  font-weight: bolder;
  line-height: 16px;
  margin-bottom: 15px;
}

.invoice-details {
  margin: 15px 0px;
}

.invoice-summary {
  margin-top: 8px;
  white-space: pre-line;
}
</style>
